import React from 'react';
import styled from 'styled-components';

const InfoContainer = styled.p(
  ({ theme }) => `
  font-size: ${theme.fonts.size.small};
  color: ${theme.colors.text.secondary};
`,
);

const SaveContextInfo = () => (
  <InfoContainer>The content you added won’t be saved unless you click Save in your dashboard or search.</InfoContainer>
);

export default SaveContextInfo;
